export const isProdRunEnv = process.env.VUE_APP_RUN_ENV === 'prod'
